import { TableViewStore, BaseListViewStore, QueryPickerStore } from "core/stores";
import { PersonService } from 'application/person/services';
import { BaasicDropdownStore } from 'core/stores'
import _ from 'lodash';
import { toDate, toUTCDate } from 'core/utils';
import { FacilityService } from "application/facility/services";
import { FacilityInventoryCountHeaderService } from "application/facility-inventory/services";
import {resolveColumns} from 'application/facility/util/resolveColumns';
import {GridBooleanCell} from 'core/components';
import { action } from 'mobx';
import applicationContext from 'core/utils/applicationContext';

@applicationContext
class FacilityOrderListViewStore extends BaseListViewStore {
	constructor(rootStore) {
        const personService = new PersonService(rootStore.application.baasic.apiClient);
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);
        const facilityInventoryCountHeaderService = new FacilityInventoryCountHeaderService(rootStore.application.baasic.apiClient);
        super(rootStore, {
			autoInit: true,
			name: 'facility-inventory',
			routes: {
				details: item => {  
					this.rootStore.routerStore.goTo(
						'master.app.main.facility-inventory.facility-inventory-detail.list',
						{ facilityInventoryCountHeaderId: item.id, isDone: item.isDone }
					);               
                },	
				// create: () => rootStore.routerStore.goTo(
                //     'master.app.main.facility-inventory.create'
                // ),
				edit: item => {         
                    this.rootStore.routerStore.goTo(
                        'master.app.main.facility-inventory.edit',
                        { id: item.id }
                    );
                },
			},
			actions: () => {
				return {
					find: async params => {						
						const response = await facilityInventoryCountHeaderService.find(_.extend(params, {
							embed: 'Facility,Author',
						}));
						const responseData = _.extend(response.data, {
							item: _.map(response.data.item, (item => {
								return _.extend(
									item, {
										facility: item.facility && item.facility.name,
										author: item.author && item.author.fullName,
										countDate: item.countDate && toUTCDate(item.countDate),
										isDone: item.isDone,
										dateCreated: item.dateCreated && toDate(item.dateCreated)
									}
								);
							}))
						});				
						return responseData;
					},
					delete: async (item) => {
                        await facilityInventoryCountHeaderService.delete(item);
                    }
				};
			},
		});

        this.countDatePickerStore = new QueryPickerStore();
        this.dateCreatedPickerStore = new QueryPickerStore();

        this.facilityInventoryCountHeaderService = facilityInventoryCountHeaderService;

        this.personStore = new BaasicDropdownStore({
			filterable: true
		}, {
            fetchFunc: async (term) => {
                const response = await personService.find({ searchQuery: term, rpp: 200, isActive:true });
                return _.map(response.data.item, item => {
                    return {
                        id: item.id,
                        name: item.firstName + ' ' + item.lastName                       
                    };
                });
            }
        });

        this.facilityStore = new BaasicDropdownStore({
			filterable: true
		},
		{
			fetchFunc: async(term) => {
				const response = await facilityService.find({ searchQuery: term, rpp: 100 });
				return _.map(response.data.item, item => {
                    return {
                        id: item.id,
                        name: item.name                      
                    };
                });
			}
		});

        this.queryUtility.onResetFilter = () => {
			this.facilityStore.setValue(null);
			this.facilityStore.filterTerm = "";

			this.personStore.setValue(null);
			this.personStore.filterTerm = "";

			this.countDatePickerStore.reset();
		}

        this.setTableStore(
			new TableViewStore(this.queryUtility, {
				columns: resolveColumns([
					{
						key: 'facility',
						title: "FACILITY_INVENTORY.LIST.COLUMNS.FACILITY",
						onClick: item => this.routes.details(item)
					},
					{
						key: 'author',
						title: "FACILITY_INVENTORY.LIST.COLUMNS.AUTHOR",
					},
					{
						key: 'countDate',
						title: "FACILITY_INVENTORY.LIST.COLUMNS.COUNT_DATE",
					},
					{
						key: 'dateCreated',
						title: "FACILITY_INVENTORY.LIST.COLUMNS.DATE_CREATED"
					},		
					{
						key: 'isDone',
						title: "FACILITY_INVENTORY.LIST.COLUMNS.IS_DONE",
						cell: GridBooleanCell,
						displayFaultyValue: true,
						width: 100,
						headerClassName: "center"
					},
				]),
				actions: {
					onEdit: item => this.routes.edit(item),
					onDelete: (item) => this.deleteResource(item),
					onDone: (item) => this.changeIsDone(item),
					onUndone: (item) => this.changeIsDone(item)
				},
			})
		);
    }

	@action.bound
	deleteResource(resource) {
        if (!this.actions.find || !this.actions.delete) return;
        
        const { modalStore, notificationStore } = this.rootStore;

        modalStore.showConfirm(
            'Are you sure you want to delete selected Inventory Count?',
            async () => {
                try {
                    await this.actions.delete(resource);
                    this.notifySuccessDelete();
                    await this.queryUtility.fetch();
                } catch (err) {
                    notificationStore.error('LIST_LAYOUT.ERROR_DELETE', err);
                }
            }
        );
    }

	@action.bound
	async changeIsDone(item) {
        this.loaderStore.suspend();
		var resource = { id: item.id, isDone: !item.isDone };
        await this.facilityInventoryCountHeaderService.changeIsDone(resource);
		if(item.isDone)
		{
			this.rootStore.notificationStore.success('FACILITY_INVENTORY.LIST.ACTIONS.SUCCESS_UNLOCK');
		}
		else
		{
			this.rootStore.notificationStore.success('FACILITY_INVENTORY.LIST.ACTIONS.SUCCESS_LOCK');
		}
        await this.queryUtility.fetch();
        this.loaderStore.resume();
    }

	@action.bound
	notifySuccessDelete() {
        this.rootStore.notificationStore.success('FACILITY_INVENTORY.LIST.ACTIONS.SUCCESS_DELETE');
    }

}

export default FacilityOrderListViewStore;